import 'virtual:uno.css'
import './assets/styles/main.css'
import { configureEcho } from '@laravel/echo-vue'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import App from './App.vue'
import globalComponents from './components'
import globalDirectives from './directives'
import { useApiToken } from './functions/api'
import router from './router'

const { getToken } = useApiToken()

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(globalComponents)
app.use(globalDirectives)
app.mount('#app')

configureEcho({
  broadcaster: 'reverb',
  key: import.meta.env.VITE_REVERB_APP_KEY,
  wsHost: import.meta.env.VITE_REVERB_HOST,
  wsPort: 443,
  wssPort: 443,
  forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
  enabledTransports: ['ws', 'wss'],
  authEndpoint: `${import.meta.env.VITE_BASE_API}/broadcasting/auth`,
  auth: {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  },
})
